import sitesAndLocationDataConfigApi from '@/api/config/sitesAndLocationDataConfigApi'
import { queryKeys } from '@/constant/common'
import { UpdateSite } from '@/types/siteLocation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'

async function updateSite(payload: UpdateSite): Promise<void> {
  await sitesAndLocationDataConfigApi.updateSite(payload)
}

function useUpdateSite() {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateSite) => updateSite(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.siteLocation])
      toast.success('Update Site Success')
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useUpdateSite
